<template>
	<div class="component-section">
		<h3 class="section-title">Form Inputs</h3>
		<div class="inputs-grid">
			<div class="form-field">
				<label>InputText</label>
				<InputText v-model="sampleText" placeholder="Enter text..." />
			</div>
			<div class="form-field">
				<label>Password</label>
				<Password v-model="samplePassword" placeholder="Password" />
			</div>
			<div class="form-field">
				<label>InputNumber</label>
				<InputNumber v-model="sampleNumber" mode="decimal" :minFractionDigits="2" placeholder="0.00" />
			</div>
			<div class="form-field">
				<label>Textarea</label>
				<Textarea v-model="sampleTextarea" rows="3" placeholder="Enter description..." />
			</div>
			<div class="form-field">
				<label>DatePicker</label>
				<DatePicker v-model="selectedDate" placeholder="Select date" class="date-picker-field" style="max-width: 200px; width: 200px;" />
			</div>
			<div class="form-field">
				<label>InputMask</label>
				<InputMask v-model="maskedValue" mask="99-999999" placeholder="99-999999" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue"
import InputText from "primevue/inputtext"
import Password from "primevue/password"
import InputNumber from "primevue/inputnumber"
import Textarea from "primevue/textarea"
import DatePicker from "primevue/datepicker"
import InputMask from "primevue/inputmask"

const emit = defineEmits<{
	(e: "elementClick", event: MouseEvent): void
}>()

const sampleText = ref("")
const samplePassword = ref("")
const sampleNumber = ref()
const sampleTextarea = ref("")
const selectedDate = ref()
const maskedValue = ref("")

const handleClick = (event: MouseEvent) => {
	emit("elementClick", event)
}
</script>

<style lang="scss" scoped>
.component-section {
	background: white;
	border-radius: 8px;
	padding: 1.5rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	margin-bottom: 1rem;
}

.section-title {
	font-size: 1.2rem;
	font-weight: 600;
	margin-bottom: 1rem;
	color: #374151;
	border-bottom: 2px solid #e5e7eb;
	padding-bottom: 0.5rem;
}

.inputs-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 1rem;
}

.form-field {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.form-field label {
	font-size: 0.875rem;
	font-weight: 500;
	color: #6b7280;
}

.date-picker-field {
	max-width: 200px !important;
	width: 200px !important;
}

:deep(.date-picker-field .p-datepicker-input) {
	max-width: 200px !important;
	width: 200px !important;
}
</style>
